// app/src/lib/ocr/receiptImages.js — local cache of original scan blobs so the
// receipt detail can show the photo the OCR saw. Keyed by receiptId at scan
// time; linked to invoiceId once the user confirms and persists.
//
// Stored locally on the writer device only. Pre-existing invoices (scanned
// before this version) have no cached image — the UI handles that case.

import { db } from '../db.js';

/**
 * Stash the captured scan blob so the receipt detail can show it later.
 * Called from Scan.jsx right after the upload PUT succeeds. Idempotent —
 * overwriting the same receiptId replaces the previous blob.
 */
export async function saveReceiptImage(receiptId, userId, blob, mimeType) {
  if (!receiptId || !userId || !(blob instanceof Blob)) return;
  await db.receiptImages.put({
    receiptId,
    invoiceId: null,
    userId,
    blob,
    mimeType: mimeType || blob.type || 'image/jpeg',
    createdAt: Date.now(),
  });
}

/**
 * Link a saved blob to its invoice once the user confirms. After this, the
 * detail screen looks the blob up by invoiceId.
 */
export async function linkReceiptImage(receiptId, invoiceId) {
  if (!receiptId || !invoiceId) return;
  const row = await db.receiptImages.get(receiptId);
  if (!row) return;
  await db.receiptImages.update(receiptId, { invoiceId });
}

/**
 * Fetch a cached blob by invoiceId. Returns null if no image was cached —
 * either the invoice predates this feature, or the scan happened on a
 * different device.
 */
export async function getReceiptImage(invoiceId) {
  if (!invoiceId) return null;
  const rows = await db.receiptImages.where('invoiceId').equals(invoiceId).toArray();
  return rows[0] || null;
}
